import { useEffect } from 'react';
import { hexToRgbArray } from '@src/utils/common';
import { useAppContext } from '@lib/AppContext';
import { PowerBranding } from '../graphql/generated';

export function usePageTheme(powerBranding: PowerBranding) {
  const { theme } = useAppContext();

  let colors = {};
  if (powerBranding) {
    colors = {
      bg: hexToRgbArray(powerBranding.power_branding_color_bg, '#000000'),
      fg: hexToRgbArray(powerBranding.power_branding_color_fg, '#FFFFFF'),
      surface: hexToRgbArray(powerBranding.power_branding_color_surface, '#181818'),
      primary: hexToRgbArray(powerBranding.power_branding_color_primary, '#FF0000'),
    };
  }

  useEffect(() => {
    if (colors && theme?.setColors) {
      theme.setColors((prevTheme) => ({
        ...prevTheme,
        ...colors,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [powerBranding]);
}
